import { Button } from '@bennows/boows-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/page-header/PageHeader';

/**
 * Route error boundary (spec 05 §6): never a blank page or a stack trace. The page frame stays
 * (style guide 2.61): an area with a sub-navigation passes it as `nav`, so only the content shows the error.
 */
export function RouteError({ nav }: { nav?: ReactNode }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="ui-stack">
      <PageHeader title={t('error.routeTitle')} />
      {nav}
      <section className="ui-error-state" role="alert">
        <p className="ui-error-state__text">{t('error.routeText')}</p>
        <Button variant="secondary" onClick={() => navigate(0)}>
          {t('error.retry')}
        </Button>
      </section>
    </div>
  );
}
